export function pathOf(url: string): string {
  return url.split(/[?#]/)[0] ?? url;
}
